import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SuccessIndicator from './components/SuccessIndicator';
import EmployeeProfile from './components/EmployeeProfile';
import TimestampDisplay from './components/TimestampDisplay';
import AutoRedirectTimer from './components/AutoRedirectTimer';
import Icon from '../../components/AppIcon';
// KioskInterfaceController removed to avoid conflicts with AutoRedirectTimer

const ClockSuccessConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data from navigation state or use mock data
  const clockData = location?.state || {};
  
  const [confirmationData, setConfirmationData] = useState({
    employee: {
      id: 'EMP001',
      name: 'Sarah Johnson',
      employeeId: 'EMP001',
      photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face',
      department: 'Manufacturing'
    },
    action: 'Einstempeln',
    timestamp: new Date()?.toISOString(),
    workingHours: '0h 0m'
  });

  // Mock data for different scenarios
  const mockScenarios = [
    {
      employee: {
        id: 'EMP001',
        name: 'Sarah Johnson',
        employeeId: 'EMP001',
        photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face',
        department: 'Manufacturing'
      },
      action: 'Einstempeln',
      workingHours: '0h 0m'
    },
    {
      employee: {
        id: 'EMP002',
        name: 'Michael Chen',
        employeeId: 'EMP002',
        photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
        department: 'Quality Control'
      },
      action: 'Ausstempeln',
      workingHours: '8h 15m'
    },
    {
      employee: {
        id: 'EMP003',
        name: 'Emily Rodriguez',
        employeeId: 'EMP003',
        photo: null, // No photo scenario
        department: 'Packaging'
      },
      action: 'Pausenbeginn',
      workingHours: '4h 30m'
    }
  ];

  useEffect(() => {
    // Merge navigation state with mock data
    const mergedData = {
      ...confirmationData,
      ...clockData
    };

    // If no specific data provided, use a random mock scenario
    if (!clockData?.employee && !clockData?.action) {
      const randomScenario = mockScenarios?.[Math.floor(Math.random() * mockScenarios?.length)];
      mergedData.employee = randomScenario?.employee;
      mergedData.action = randomScenario?.action;
      mergedData.workingHours = randomScenario?.workingHours;
    }

    setConfirmationData(mergedData);
  }, [clockData]);

  const handleRedirect = () => {
    // Clear any session data
    sessionStorage.removeItem('current_clock_session');
    
    // Navigate back to kiosk interface
    navigate('/kiosk-clock-interface', { 
      replace: true,
      state: { fromSuccess: true }
    });
  };

  // Removed handleKioskStateChange since KioskInterfaceController is no longer used

  return (
    <div className="min-h-screen bg-background">
      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Success Indicator */}
          <div className="text-center">
            <SuccessIndicator 
              action={confirmationData?.action}
            />
          </div>

          {/* Employee Profile and Timestamp Row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            {/* Employee Profile */}
            <div className="flex justify-center">
              <EmployeeProfile 
                employee={confirmationData?.employee}
              />
            </div>

            {/* Timestamp Display */}
            <div className="flex justify-center">
              <TimestampDisplay 
                timestamp={confirmationData?.timestamp}
                action={confirmationData?.action}
                className="w-full max-w-sm"
              />
            </div>
          </div>

          {/* Working Hours Display */}
          {confirmationData?.workingHours && (
            <div className="flex justify-center">
              <div className="bg-card border border-border rounded-lg p-6 text-center max-w-sm">
                <div className="flex items-center justify-center space-x-2 mb-3">
                  <Icon 
                    name="Clock" 
                    size={20} 
                    className="text-text-secondary"
                  />
                  <span className="text-lg font-medium text-text-secondary">
                    Stunden Heute
                  </span>
                </div>
                <div className="text-2xl font-bold text-text-primary">
                  {confirmationData.workingHours}
                </div>
              </div>
            </div>
          )}

          {/* Auto Redirect Timer */}
          <AutoRedirectTimer 
            redirectDelay={7000}
            redirectPath="/kiosk-clock-interface"
            onRedirect={handleRedirect}
          />


          {/* Footer Message */}
          <div className="text-center text-text-secondary">
            <p className="text-lg">
              {confirmationData?.action?.toLowerCase() === 'einstempeln' ? 'Willkommen! Dein Arbeitstag hat begonnen.'
                : confirmationData?.action?.toLowerCase() === 'ausstempeln' ? 'Danke für deine Arbeit heute!' : 'Aktion erfolgreich erfasst.'}
            </p>
            <p className="text-sm mt-2">
              Dieser Bildschirm kehrt automatisch zur Hauptansicht zurück
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClockSuccessConfirmation;